/* eslint-disable no-shadow */
import { useContext, useEffect, useState } from 'react'
import { UserContext } from 'context'
import { Icon } from 'assets/index'
import {
  InfoCard,
  ResumeInputCard,
  ResumeSelectCard,
  Path,
  Checkbox,
} from 'components/index'
import { useStorage, useFetch } from 'hooks'
import { IMask } from 'react-imask'
import {
  optionsLevels,
  clearString,
  dateToTimestamp,
  hasAccess,
} from 'helper/utils'
import validate from '../../../../helper/validate.js'
import Document from '../../Components/Document'
import { Container } from './style'

const getCurrent18 = () => {
  const now = new Date()
  return now.getFullYear() - 18
}

const enterpriseOptions = [
  { label: 'MEI', value: 'mei' },
  { label: 'LTDA', value: 'ltda' },
  { label: 'Sociedade Anônima', value: 'sa' },
  { label: 'Associação', value: 'association' },
  { label: 'Empresário Individual', value: 'me' },
]

const optionsCivil = [
  { label: 'Solteiro', value: 'SINGLE' },
  { label: 'Casado', value: 'MARRIED' },
  { label: 'Divorciado', value: 'DIVORCED' },
  { label: 'Viúvo', value: 'WIDOWER' },
]

const optionsTypePix = [
  { value: 'CPF', label: 'CPF' },
  { value: 'CNPJ', label: 'CNPJ' },
  { value: 'PHONE', label: 'Telefone' },
  { value: 'EMAIL', label: 'E-mail' },
  { value: 'EVP', label: 'Aleatória' },
]

export default function Informacoes() {
  const { data, setData } = useContext(UserContext)
  const [text, setText] = useState<string>('')
  const [loading, setLoading] = useState<any>(false)
  const [user] = useStorage('User')
  const api = useFetch()
  const [clickable, setClickable] = useState<any>()
  const [keyPixError, setKeyPixError] = useState<string>('')
  const [typePixError, setTypePixError] = useState<string>('')
  const [pixMask, setPixMask] = useState<string>()

  const handleUpdate = (key: string, value: any) => {
    return new Promise((resolve) => {
      const form = new FormData()
      if (typeof value === 'object') value = JSON.stringify(value)
      form.set(key, value)
      if (data.account.status === 'ACTIVE' && key !== 'customData') {
        form.set('customData', JSON.stringify({ analyzeFields: [key] }))
      }

      api
        .fetch(
          'post',
          form,
          `/gestor/account/${clearString(data.user.document)}`,
          {
            'Content-type': 'multipart/form-data',
          }
        )
        .then(resolve)
        .catch((reject) => {
          console.error(reject)
        })
    })
  }

  const getStateCity = (text: any) => {
    return api.fetch('get', null, `/app/get-address/${text}`)
  }

  const isError = (obj: any) => {
    return !obj || obj === '--'
  }

  const validatePixKey = (type: string, value: string): string => {
    const validationRules: { [key: string]: (value: string) => boolean } = {
      CPF: (v) => !!validate.numbers.cpf(v), // Converte para booleano
      CNPJ: (v) => !!validate.numbers.cnpj(v), // Converte para booleano
      PHONE: (v) => !!validate.numbers.cellphonePix(v), // Converte para booleano
      EMAIL: (v) => !!validate.string.email(v), // Converte para booleano
      EVP: (v) => !!v,
    }

    if (!type) return 'Campo obrigatório' // Validação do tipo
    if (!value) return 'Campo obrigatório' // Validação do valor
    if (!validationRules[type]) return 'Tipo inválido' // Tipo não suportado

    const isValid = validationRules[type](value) // Executa a validação correspondente

    if (!isValid) {
      // Retorna mensagens específicas para CELLPHONE e EMAIL
      if (type === 'PHONE') return 'Telefone inválido'
      if (type === 'EMAIL') return 'E-mail inválido'
      return `${type} inválido` // Mensagem genérica para outros tipos
    }

    return '' // Retorna vazio se for válido
  }

  useEffect(() => {
    const pixType = data.account?.pixList[0]?.type
    const pixKey = data.account?.pixList[0]?.key
    const error = validatePixKey(pixType, pixKey)

    if (pixType && pixKey) {
      setKeyPixError(error)
    }
    if (pixType && !pixKey) {
      setKeyPixError(error)
    }
    if (!pixType && pixKey) {
      setTypePixError(error)
    }
  }, []) // Validação do pix quando a tela é renderizada

  return (
    <Container>
      <Path className="path">
        <span className="path">{'Detalhes do cliente > Informações'}</span>
      </Path>
      <h1 className="detalhes-captacao-title">{data.user.name}</h1>
      <div className="detalhes-container123">
        <h4 className="status-span">
          Conta {data.user.type === 'CPF' ? 'pessoa física' : 'pessoa jurídica'}
        </h4>
        <img
          className="status-icon"
          src={Icon('undefined.svg')}
          alt="status icon"
        />
        {data.account.status !== 'ACTIVE' && (
          <span className="status-span">{data.account.status}</span>
        )}
      </div>
      <div className="status-card-container-cards">
        <h1 className="detalhes-captacao-title">Dados da conta</h1>
        <InfoCard icon={Icon('calendar.svg')} value={data.account.createdAt}>
          Data de criação
        </InfoCard>
        <InfoCard icon={Icon('calendar.svg')} value={data.account.activatedAt}>
          Data de ativação
        </InfoCard>
        <h1 className="detalhes-captacao-title">Dados pessoais</h1>
        <InfoCard icon={Icon('profile.svg')} value={data.user.document}>
          {data.user.type}
        </InfoCard>
        {data.user.type === 'CPF' && (
          <ResumeInputCard
            id={'editar-card-info-cliente-name'}
            analyze={
              data?.account?.customData?.analyzeFields &&
              data?.account?.customData?.analyzeFields?.includes('name')
            }
            // clickable={!clickable || clickable === 'name'}
            onClickEdit={() => setClickable('name')}
            erro={isError(data.user.name)}
            loading={loading === 'name'}
            onClickOK={() => {
              if (text.length === 0) return
              setLoading('name')
              handleUpdate('name', text).then(() => {
                setData((old: any) => ({
                  ...old,
                  user: {
                    ...old.user,
                    name: text,
                  },
                }))
                setLoading(false)
                setClickable(false)
              })
            }}
            handleChangeInput={(e: string) => {
              setText(e)
            }}
            clickable={
              hasAccess('editar-card-info-cliente-name') &&
              (!clickable || clickable === 'name')
            }
            names="name"
            icon="profile.svg"
            // isMask={'00.000.000'}
            placeholder={data.user.name}
            small
          >
            Nome completo
          </ResumeInputCard>
        )}
        {data.user.type === 'CPF' && (
          <ResumeInputCard
            analyze={
              data?.account?.customData?.analyzeFields &&
              data?.account?.customData?.analyzeFields?.includes('rg')
            }
            // clickable={!clickable || clickable === 'rg'}
            onClickEdit={() => setClickable('rg')}
            erro={isError(data.user.rg)}
            loading={loading === 'rg'}
            maxWidth={210}
            onClickOK={() => {
              if (text.length === 0) return
              setLoading('rg')
              const body =
                data.account.status === 'ACTIVE'
                  ? { rg: text, analyzeFields: ['rg'] }
                  : { rg: text }

              handleUpdate('customData', JSON.stringify(body)).then(() => {
                setData((old: any) => ({
                  ...old,
                  user: {
                    ...old.user,
                    rg: text,
                  },
                }))
                setLoading(false)
                setClickable(false)
              })
            }}
            handleChangeInput={(e: string) => {
              setText(e)
            }}
            clickable={
              hasAccess('editar-card-info-cliente-rg') &&
              (!clickable || clickable === 'rg')
            }
            id={'editar-card-info-cliente-rg'}
            names="rg"
            icon="profile.svg"
            isMask={'00.000.000-00'}
            placeholder={data.user.rg}
            small
          >
            RG
          </ResumeInputCard>
        )}
        {data.user.type === 'CPF' && (
          <ResumeInputCard
            analyze={
              data?.account?.customData?.analyzeFields &&
              data?.account?.customData?.analyzeFields?.includes('birthDate')
            }
            maxWidth={210}
            onClickEdit={() => setClickable('birthday')}
            erro={isError(data.user.birthDate)}
            loading={loading === 'birthday'}
            id={'editar-card-info-cliente-birthdate'}
            clickable={
              hasAccess('editar-card-info-cliente-birthdate') &&
              (!clickable || clickable === 'birthday')
            }
            names="birthday"
            icon="calendar.svg"
            isMask="d/m/Y"
            blocks={{
              d: {
                mask: IMask.MaskedRange,
                from: 1,
                to: 31,
                maxLength: 2,
              },
              m: {
                mask: IMask.MaskedRange,
                from: 1,
                to: 12,
                maxLength: 2,
              },
              Y: {
                mask: IMask.MaskedRange,
                from: 1900,
                to: getCurrent18(),
              },
            }}
            placeholder={data.user.birthDate}
            small
            onClickOK={() => {
              if (text.length === 0) return
              setLoading('birthday')
              handleUpdate('birthDate', dateToTimestamp(text)).then(() => {
                setData((old: any) => ({
                  ...old,
                  user: {
                    ...old.user,
                    birthDate: text,
                  },
                }))
              })
              setLoading(false)
              setClickable(false)
            }}
            handleChangeInput={(e: string) => {
              setText(e)
            }}
          >
            Data de nascimento
          </ResumeInputCard>
        )}
        <ResumeInputCard
          analyze={
            data?.account?.customData?.analyzeFields &&
            data?.account?.customData?.analyzeFields?.includes('cellphone')
          }
          isMask="(00) 00000-0000"
          onClickEdit={() => setClickable('whatsapp')}
          erro={isError(data.account.cellphone)}
          loading={loading === 'whatsapp'}
          id={'editar-card-info-cliente-cellphone'}
          clickable={
            hasAccess('editar-card-info-cliente-cellphone') &&
            (!clickable || clickable === 'whatsapp')
          }
          names="whatsapp"
          icon="whats.svg"
          placeholder={data.account.cellphone}
          small
          onClickOK={() => {
            if (text.length === 0) return
            setLoading('whatsapp')
            handleUpdate('cellphone', text).then(() => {
              setData((old: any) => ({
                ...old,
                account: {
                  ...old.account,
                  cellphone: text,
                },
              }))
              setLoading(false)
              setClickable(false)
            })
          }}
          handleChangeInput={(e: string) => {
            setText(e)
          }}
        >
          WhatsApp
        </ResumeInputCard>
        <ResumeInputCard
          analyze={
            data?.account?.customData?.analyzeFields &&
            data?.account?.customData?.analyzeFields?.includes('email')
          }
          onClickEdit={() => setClickable('email')}
          erro={isError(data.account.email)}
          loading={loading === 'email'}
          clickable={
            hasAccess('editar-card-info-cliente-email') &&
            (!clickable || clickable === 'email')
          }
          id={'editar-card-info-cliente-email'}
          names="email"
          icon="mail.svg"
          placeholder={data.account.email}
          small
          onClickOK={() => {
            if (text.length === 0) return
            setLoading('email')
            handleUpdate('email', text).then(() => {
              setData((old: any) => ({
                ...old,
                account: {
                  ...old.account,
                  email: text,
                },
              }))
              setLoading(false)
              setClickable(false)
            })
          }}
          handleChangeInput={(e: string) => {
            setText(e)
          }}
        >
          E-mail
        </ResumeInputCard>
        {data.user.type === 'CPF' && (
          <ResumeSelectCard
            disabled={!hasAccess('editar-card-info-cliente-civilState')}
            id="editar-card-info-cliente-civil"
            analyze={
              data?.account?.customData?.analyzeFields &&
              data?.account?.customData?.analyzeFields?.includes('civilState')
            }
            erro={
              !optionsCivil.find(
                (item: any) => item.value === data.user.civilState
              )?.label
            }
            name={
              optionsCivil.find(
                (item: any) => item.value === data.user.civilState
              )?.label || 'Selecionar'
            }
            icon={`profile.svg`} // specialist?.profilePic
            options={optionsCivil}
            small
            text=""
            handleChange={(e: any) => {
              handleUpdate('civilState', e.value).then(() => {
                setData((old: any) => ({
                  ...old,
                  user: {
                    ...old.user,
                    civilState: e.value,
                  },
                }))
              })
            }}
          >
            Estado Civil
          </ResumeSelectCard>
        )}
        {data.user.type !== 'CPF' && (
          <ResumeSelectCard
            disabled={!hasAccess('editar-card-info-cliente-ciaType')}
            id="editar-card-info-cliente-ciaType"
            analyze={
              data?.account?.customData?.analyzeFields &&
              data?.account?.customData?.analyzeFields?.includes(
                'enterpriseType'
              )
            }
            erro={
              !enterpriseOptions.find(
                (item: any) =>
                  item.value === data.user.customData.enterpriseType
              )?.label
            }
            name={
              enterpriseOptions.find(
                (item: any) =>
                  item.value === data.user.customData.enterpriseType
              )?.label || 'Selecionar'
            }
            icon={`profile.svg`} // specialist?.profilePic
            options={enterpriseOptions}
            text=""
            handleChange={(e: any) => {
              handleUpdate('enterpriseType', e.value).then(() => {
                setData((old: any) => ({
                  ...old,
                  user: {
                    ...old.user,
                    customData: {
                      ...old.user.customData,
                      enterpriseType: e.value,
                    },
                  },
                }))
              })
            }}
          >
            Tipo de Empresa
          </ResumeSelectCard>
        )}

        {data.spouse ? (
          <>
            <h1 className="detalhes-captacao-title">Dados do conjuge</h1>
            <InfoCard icon={Icon('whats.svg')} value={data.spouse.name}>
              Nome do conjuge
            </InfoCard>
            <InfoCard icon={Icon('mail.svg')} value={data.spouse.document}>
              CPF
            </InfoCard>
            <InfoCard icon={Icon('mail.svg')} value={data.spouse.rg}>
              RG
            </InfoCard>
            <InfoCard icon={Icon('calendar.svg')} value={data.spouse.birthDate}>
              Data de nascimento
            </InfoCard>
            <InfoCard icon={Icon('whats.svg')} value={data.spouse.cellphone}>
              WhatsApp
            </InfoCard>
            <InfoCard icon={Icon('mail.svg')} value={data.spouse.email}>
              E-mail
            </InfoCard>
          </>
        ) : null}
        <h1 className="detalhes-captacao-title">Endereço</h1>
        <ResumeInputCard
          analyze={
            data?.account?.customData?.analyzeFields &&
            data?.account?.customData?.analyzeFields?.includes('address')
          }
          isMask="00000-000"
          onClickEdit={() => setClickable('postalCode')}
          erro={isError(data.address.postalCode)}
          loading={loading === 'postalCode'}
          handleChangeInput={(e: string) => {
            setText(e)
          }}
          onClickOK={async () => {
            setLoading('postalCode')
            const r: any = await getStateCity(text)

            let body = data.address
            if (text.length > 0) {
              body = {
                ...data.address,
                postalCode: text,
              }
            }
            if (typeof r.data !== 'string' && !r.fail) {
              body = {
                ...data.address,
                ...r.data,
                postalCode: text,
              }
            }
            if (!text && !data?.address?.postalCode) {
              body = {}
            }

            handleUpdate('address', JSON.stringify({ ...body })).then(() => {
              setData((old: any) => ({
                ...old,
                address: { ...body },
              }))
              setLoading(false)
              setClickable(false)
            })
          }}
          clickable={
            hasAccess('editar-card-info-cliente-cep') &&
            (!clickable || clickable === 'postalCode')
          }
          id="editar-card-info-cliente-cep"
          names="whatsapp"
          icon="pin.svg"
          placeholder={data?.address?.postalCode || '--'}
          small
        >
          CEP
        </ResumeInputCard>

        {data?.address?.postalCode && (
          <>
            <InfoCard icon={Icon('pin.svg')} value={data.address.state || '--'}>
              Estado
            </InfoCard>
            <InfoCard icon={Icon('pin.svg')} value={data.address.city || '--'}>
              Cidade
            </InfoCard>
            <ResumeInputCard
              analyze={
                data?.account?.customData?.analyzeFields &&
                data?.account?.customData?.analyzeFields?.includes('address')
              }
              onClickEdit={() => setClickable('province')}
              erro={isError(data.address.province)}
              loading={loading === 'province'}
              handleChangeInput={(e: string) => {
                setText(e)
              }}
              onClickOK={() => {
                if (text.length === 0) return
                setLoading('province')
                handleUpdate(
                  'address',
                  JSON.stringify({ ...data.address, province: text })
                ).then(() => {
                  setData((old: any) => ({
                    ...old,
                    address: {
                      ...old.address,
                      province: text,
                    },
                  }))
                  setLoading(false)
                  setClickable(false)
                })
              }}
              clickable={
                hasAccess('editar-card-info-cliente-province') &&
                (!clickable || clickable === 'province')
              }
              id="editar-card-info-cliente-province"
              names="whatsapp"
              icon="pin.svg"
              placeholder={data?.address?.province || '--'}
              small
            >
              Bairro
            </ResumeInputCard>
            <ResumeInputCard
              analyze={
                data?.account?.customData?.analyzeFields &&
                data?.account?.customData?.analyzeFields?.includes('address')
              }
              onClickEdit={() => setClickable('address')}
              erro={isError(data.address.address)}
              loading={loading === 'address'}
              handleChangeInput={(e: string) => {
                setText(e)
              }}
              onClickOK={() => {
                if (text.length === 0) return
                setLoading('address')
                handleUpdate(
                  'address',
                  JSON.stringify({ ...data.address, address: text })
                ).then(() => {
                  setData((old: any) => ({
                    ...old,
                    address: {
                      ...old.address,
                      address: text,
                    },
                  }))
                  setLoading(false)
                  setClickable(false)
                })
              }}
              clickable={
                hasAccess('editar-card-info-cliente-address') &&
                (!clickable || clickable === 'address')
              }
              id={'editar-card-info-cliente-address'}
              names="whatsapp"
              icon="pin.svg"
              placeholder={data?.address?.address || '--'}
              small
            >
              Rua
            </ResumeInputCard>
            <ResumeInputCard
              analyze={
                data?.account?.customData?.analyzeFields &&
                data?.account?.customData?.analyzeFields?.includes('address')
              }
              onClickEdit={() => setClickable('number')}
              erro={isError(data.address.number)}
              loading={loading === 'number'}
              handleChangeInput={(e: string) => {
                setText(e)
              }}
              onClickOK={() => {
                if (text.length === 0) return
                setLoading('number')
                handleUpdate(
                  'address',
                  JSON.stringify({ ...data.address, number: text })
                ).then(() => {
                  setData((old: any) => ({
                    ...old,
                    address: {
                      ...old.address,
                      number: text,
                    },
                  }))
                  setLoading(false)
                  setClickable(false)
                })
              }}
              clickable={
                hasAccess('editar-card-info-cliente-number') &&
                (!clickable || clickable === 'number')
              }
              names="whatsapp"
              icon="pin.svg"
              placeholder={data?.address?.number || '--'}
              small
            >
              Número
            </ResumeInputCard>
            <ResumeInputCard
              analyze={
                data?.account?.customData?.analyzeFields &&
                data?.account?.customData?.analyzeFields?.includes('address')
              }
              onClickEdit={() => setClickable('complement')}
              erro={isError(data.address.complement)}
              loading={loading === 'complement'}
              handleChangeInput={(e: string) => {
                setText(e)
              }}
              onClickOK={() => {
                if (text.length === 0) return
                setLoading('complement')
                handleUpdate(
                  'address',
                  JSON.stringify({ ...data.address, complement: text })
                ).then(() => {
                  setData((old: any) => ({
                    ...old,
                    address: {
                      ...old.address,
                      complement: text,
                    },
                  }))
                  setLoading(false)
                  setClickable(false)
                })
              }}
              clickable={
                hasAccess('editar-card-info-cliente-complement') &&
                (!clickable || clickable === 'complement')
              }
              id="editar-card-info-cliente-complement"
              names="whatsapp"
              icon="pin.svg"
              placeholder={data?.address?.complement || '--'}
              small
            >
              Complemento
            </ResumeInputCard>

            <h1 className="detalhes-captacao-title">Dados bancários</h1>
            <ResumeInputCard
              analyze={
                data?.account?.customData?.analyzeFields &&
                data?.account?.customData?.analyzeFields?.includes('pix')
              }
              onClickEdit={() => setClickable('institution')}
              erro={isError(data.account?.pixList[0]?.institution)}
              loading={loading === 'institution'}
              onClickOK={() => {
                if (text.length === 0) return
                setLoading('institution')
                handleUpdate(
                  'pix',
                  JSON.stringify({
                    key: data.account?.pixList[0]?.key,
                    institution: text,
                    type: data.account?.pixList[0]?.type,
                  })
                ).then(() => {
                  setData((old: any) => ({
                    ...old,
                    account: {
                      ...old.account,
                      pixList: [
                        {
                          ...old.account?.pixList[0],
                          institution: text,
                          type: data.account?.pixList[0]?.type,
                        },
                      ],
                    },
                  }))
                  setLoading(false)
                  setClickable(false)
                })
              }}
              handleChangeInput={(e: string) => {
                setText(e)
              }}
              clickable={
                hasAccess('editar-card-info-cliente-bank') &&
                (!clickable || clickable === 'institution')
              }
              id={'editar-card-info-cliente-bank'}
              names="institution"
              icon="profile.svg"
              placeholder={data.account?.pixList[0]?.institution}
              small
            >
              Banco
            </ResumeInputCard>
            <ResumeSelectCard
              disabled={!hasAccess('editar-card-info-cliente-pixType')}
              id="editar-card-info-cliente-pixType"
              analyze={
                data?.account?.customData?.analyzeFields &&
                data?.account?.customData?.analyzeFields?.includes('pix')
              }
              erro={isError(data.account?.pixList[0]?.type) || typePixError}
              name={
                optionsTypePix.find((item: any) => {
                  return item.value === data.account.pixList[0]?.type
                })?.label || 'Selecionar'
              }
              options={optionsTypePix}
              text=""
              handleChange={(e: any) => {
                const pixType = e.value

                if (pixType === 'PHONE') {
                  setPixMask('+55 (00) 00000-0000')
                }
                if (pixType === 'CPF') {
                  setPixMask('000.000.000-00')
                }
                if (pixType === 'CNPJ') {
                  setPixMask('00.000.000/0000-00')
                }
                if (pixType === 'EMAIL' || pixType === 'EVP' || !pixType) {
                  setPixMask('')
                }
                const errorMessage = validatePixKey(
                  pixType,
                  data.account?.pixList[0]?.key
                )
                const pixKey = data.account?.pixList[0]?.key

                if (errorMessage) {
                  if (pixType) setKeyPixError(errorMessage)
                } else {
                  setKeyPixError('')
                }

                if (pixType) {
                  setTypePixError('')
                }

                handleUpdate(
                  'pix',
                  JSON.stringify({
                    key: pixKey,
                    institution: data.account?.pixList[0]?.institution,
                    type: e.value,
                  })
                ).then(() => {
                  setData((old: any) => ({
                    ...old,
                    account: {
                      ...old.account,
                      pixList: [
                        {
                          ...old.account?.pixList[0],
                          type: e.value,
                        },
                      ],
                    },
                  }))
                })
              }}
              icon="lock_open.svg"
              small
              errorMsg={typePixError}
            >
              Tipo chave Pix
            </ResumeSelectCard>
            <ResumeInputCard
              isMask={pixMask}
              analyze={
                data?.account?.customData?.analyzeFields &&
                data?.account?.customData?.analyzeFields?.includes('pix')
              }
              onClickEdit={() => {
                const pixType = data.account?.pixList[0]?.type

                if (!pixType) {
                  setTypePixError('Selecione um tipo de chave')
                  return
                }
                setClickable('key')
              }}
              erro={
                isError(data.account?.pixList[0]?.key) ||
                keyPixError ||
                typePixError
              }
              loading={loading === 'key'}
              onClickOK={() => {
                if (text.length === 0) return

                const pixType = data.account?.pixList[0]?.type
                const errorMessage = validatePixKey(pixType, text)

                if (errorMessage) {
                  if (pixType) setKeyPixError(errorMessage)
                  else setTypePixError(errorMessage)
                } else {
                  setKeyPixError('')
                  setTypePixError('')
                }
                // Lógica de validação de chave e tipo Pix

                setLoading('key')
                handleUpdate(
                  'pix',
                  JSON.stringify({
                    key: text,
                    institution: data.account?.pixList[0]?.institution,
                    type: data.account?.pixList[0]?.type,
                  })
                ).then(() => {
                  setData((old: any) => ({
                    ...old,
                    account: {
                      ...old.account,
                      pixList: [
                        {
                          ...old.account?.pixList[0],
                          key: text,
                        },
                      ],
                    },
                  }))
                  setLoading(false)
                  setClickable(false)
                })
              }}
              handleChangeInput={(e: string) => {
                setText(e)
              }}
              clickable={
                hasAccess('editar-card-info-cliente-pixKey') &&
                (!clickable || clickable === 'key')
              }
              id="editar-card-info-cliente-pixKey"
              names="key"
              icon="profile.svg"
              // isMask={'00.000.000-00'}
              placeholder={data.account?.pixList[0]?.key}
              small
              errorMsg={keyPixError}
            >
              Chave Pix
            </ResumeInputCard>
          </>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: 30,
        }}
      >
        <div style={{ marginRight: 20 }}>
          <Checkbox
            loading={loading === 'analyzePicture'}
            disabled={!hasAccess('analisar-documento-checkbox')}
            label="Analisar fotos de documentos"
            setChecked={(state) => {
              setLoading('analyzePicture')
              handleUpdate(
                'customData',
                JSON.stringify({ analyzePicture: state })
              ).then(() => {
                setData((old: any) => ({
                  ...old,
                  user: {
                    ...old.user,
                    customData: {
                      ...old.user.customData,
                      analyzePicture: state,
                    },
                  },
                }))
                setLoading(false)
              })
            }}
            checked={data?.user?.customData?.analyzePicture}
          />
        </div>
        {data?.account?.customData?.analyzeFields && (
          <Checkbox
            disabled={!hasAccess('analisar-campos-checkbox')}
            loading={loading === 'analyzeFields'}
            label="Analisar Dados"
            setChecked={() => {
              setLoading('analyzeFields')
              handleUpdate(
                'customData',
                JSON.stringify({ analyzeFields: false })
              ).then(() => {
                setData((old: any) => ({
                  ...old,
                  account: {
                    ...old.account,
                    customData: {
                      ...old.account.customData,
                      analyzeFields: false,
                    },
                  },
                }))
                setLoading(false)
              })
            }}
            checked={data?.account?.customData?.analyzeFields}
          />
        )}
      </div>
      <Document
        readonly={!hasAccess('upload-document-client')}
        pf={data.user.type === 'CPF'}
        document={data.user.document}
        documentList={data.account.documentList}
      />
    </Container>
  )
}
